import React, { useEffect } from "react";
import { useHistory } from "react-router-dom"

// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
  Table,
  Badge,
  Modal,
  Form,
  Input,
  FormGroup
} from "reactstrap";

import {
  Box,
  Button,
  IconButton,
  Avatar,
  TableContainer,
  Typography,
} from "@mui/material"

import Flatpickr from "react-flatpickr";
import Select from "react-select";

import SweetAlert from "react-bootstrap-sweetalert";
import { ToastContainer } from "react-toastify";
import notification from "assets/ringtone.ogg";

import TimerRow from "components/TimerTable/TimerRow"
import TimerTable from "components/TimerTable/TimerTable"
import LanguageDependentText from "components/TimerTable/LanguageDependentText";
import { useHuntTrackerContext } from "tracker-context";
import { getDataCenterName, extractPatchInfo, extractHuntInfo } from "sessions/gameInfo";

import { SocketIO } from "sessions/socket"
import { huntInfos } from "sessions/resources/hunts";
import { SessionConfigs } from "sessions/sessionState";
import { dataCenters } from "sessions/resources/datacenters";

const TrainSchedule = (props) => {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const audioRef = React.createRef();
  const rankType = props.match.path.split("/")[1];

  const [controller, dispatch] = useHuntTrackerContext();
  const { language, dataCenter, user } = controller;

  const [schedules, setSchedules] = React.useState([]);
  const scheduleRef = React.useRef();
  scheduleRef.current = schedules;

  const [newSchedule, setNewSchedule] = React.useState({show: false, conductor: "", conductorNote: "", patch: "", world: "", date: new Date(), time: new Date()});
  const [editSchedule, setEditSchedule] = React.useState({show: false, id: "", date: new Date(), time: new Date()});
  const [trainStatus, setTrainStatus] = React.useState({show: false, hunts: []});

  const [datacenter, setDataCenter] = React.useState(null);
  const patchList = extractPatchInfo();
  const textLibrary = SessionConfigs.dictionaryLookup;

  const dataCenterTravel = async () => {
    if (props.match.params["world"]) {
      const worldKey = props.match.params["world"];
      for (var key of Object.keys(dataCenters)) {
        if (key.toLocaleLowerCase() === worldKey.toLocaleLowerCase()) {
          await SessionConfigs.setDataCenter(key);
          await SessionConfigs.syncSession();
          return;
        }

        for (var world of dataCenters[key]["Names"]) {
          if (world.toLocaleLowerCase() === worldKey.toLocaleLowerCase()) {
            await SessionConfigs.setDataCenter(key);
            await SessionConfigs.setWorldSelectOnly(rankType, world);
            await SessionConfigs.syncSession();
          }
        }
      }
    }
  }

  const socket = SocketIO.getSocket();

  const [loadingState, setLoadingState] = React.useState(true);
  React.useEffect(() => {
    dataCenterTravel().then(() => {
      if (SessionConfigs.getDataCenter() == "") {
        history.push("/index", {replace: true});
        return;
      };
      setDataCenter(SessionConfigs.getDataCenter());
      
      SessionConfigs.queryData("/api/trainSchedule", {
        "DataCenter": SessionConfigs.getDataCenter()
      }).then((response) => {
        if (response.status == 200) {
          for (let i in response.data) {
            response.data[i].show = timerConfigs.world[response.data[i].worldName] && timerConfigs.patch[response.data[i].patchName]
          }
          setSchedules(response.data.sort((a,b) => a.departTime - b.departTime));
          setLoadingState(false);
        } else {
          history.push("/serverError");
        }
      }).catch((error) => {
        SessionConfigs.displayError(error, setAlert);
      });
      
    });

    socket.on("TrainScheduleUpdate", (message) => {
      if (message.hasOwnProperty("remove")) {
        setSchedules([...scheduleRef.current.filter((schedule) => schedule.id != message["remove"])]);
      } else {
        setSchedules((schedules) => {
          for (var i in schedules) {
            if (schedules[i].id == message.id) return schedules;
          }
          return [...schedules, message].sort((a,b) => a.departTime - b.departTime);
        })
      }
    });

    return () => {
      socket.off("TrainScheduleUpdate");
    }

  }, []);

  React.useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = SessionConfigs.getAudioVolume();
    }
  }, [audioRef.current]);

  var timerConfigs = SessionConfigs.getToggleStates(rankType);
  const worlds = Object.keys(timerConfigs.world);
  const patches = Object.keys(timerConfigs.patch);
  var lastClick = new Date().getTime();
  var lastClickType = "";

  const updateDisplayStatus = () => {
    for (let i in schedules) {
      schedules[i].show = timerConfigs.world[schedules[i].worldName] && timerConfigs.patch[schedules[i].patchName]
    }
    setSchedules([...schedules.sort((a,b) => a.departTime - b.departTime)]);
  }

  const toggleWorldState = (type, world, event) => {
    var newClick = new Date().getTime();

    if (newClick - lastClick < 300 && lastClickType == world) {
      lastClick = newClick;

      for (var i = 0; i < worlds.length; i++) {
        if (worlds[i] != world) {
          document.getElementById(type+worlds[i]).classList.remove("btn-selected");
        } else {
          document.getElementById(type+worlds[i]).classList.add("btn-selected");
        }
      }
      SessionConfigs.setWorldSelectOnly(type, world);
      updateDisplayStatus();

    } else {
      lastClick = newClick;
      lastClickType = world;

      event.currentTarget.classList.toggle("btn-selected");
      const state = event.currentTarget.classList.contains("btn-selected");
      SessionConfigs.setWorldSelect(type, world, state);
      updateDisplayStatus();
    }
  }
  
  const togglePatchState = (type, patch, event) => {
    var newClick = new Date().getTime();
    if (newClick - lastClick < 300 && lastClickType == patch) {
      lastClick = newClick;
      
      for (var i = 0; i < patches.length; i++) {
        if (patches[i] != patch) {
          document.getElementById(type+patches[i]).classList.remove("btn-selected");
        } else {
          document.getElementById(type+patches[i]).classList.add("btn-selected");
        }
      }
      SessionConfigs.setPatchSelectOnly(type, patch);
      updateDisplayStatus();

    } else {
      lastClick = newClick;
      lastClickType = patch;

      event.currentTarget.classList.toggle("btn-selected");
      const state = event.currentTarget.classList.contains("btn-selected");
      SessionConfigs.setPatchSelect(type, patch, state);
      updateDisplayStatus();
    }
  }

  const submitNewTrainSchedule = () => {
    const localeString = newSchedule.date.toLocaleDateString("en", {
      year: 'numeric', 
      month: 'numeric', 
      day: 'numeric'
    }) + " " + newSchedule.time.toLocaleTimeString("en", {
      hour: 'numeric', 
      minute: 'numeric', 
      second: 'numeric',
      hourCycle: 'h23',
    });

    SessionConfigs.queryData("/api/trainSchedule", {
      "newSchedule": true,
      "conductor": newSchedule.conductor,
      "conductorNote": newSchedule.conductorNote,
      "worldName": newSchedule.world.value,
      "patchName": newSchedule.patch.value,
      "recurring": newSchedule.recurring.value,
      "datetime": new Date(localeString).getTime()
    }).then((response) => {
      setNewSchedule({...newSchedule, show: false});
      if (scheduleRef.current.filter((value) => {
        return (value.id == response.data.id);
      }).length == 0) {
        setSchedules([...scheduleRef.current, response.data].sort((a,b) => a.departTime - b.departTime));
      } else {
        setSchedules((schedules) => {
          for (var i in schedules) {
            if (schedules[i].id == response.data.id) {
              schedules[i].owned = true;
            }
          }
          return [...schedules];
        });
      }

    }).catch((error) => {
      SessionConfigs.displayError(error, setAlert);
    });
  };

  const submitEditTrainSchedule = () => {
    const localeString = editSchedule.date.toLocaleDateString("en", {
      year: 'numeric', 
      month: 'numeric', 
      day: 'numeric'
    }) + " " + editSchedule.time.toLocaleTimeString("en", {
      hour: 'numeric', 
      minute: 'numeric', 
      second: 'numeric',
      hourCycle: 'h23',
    });

    SessionConfigs.queryData("/api/trainSchedule", {
      "editSchedule": true,
      "id": editSchedule.id,
      "datetime": new Date(localeString).getTime()
    }).then((response) => {
      setEditSchedule({show: false, date: new Date(), time: new Date()});
    }).catch((error) => {
      SessionConfigs.displayError(error, setAlert);
    });
  };

  const deleteTrainSchedule = (id) => {
    SessionConfigs.queryData("/api/trainSchedule", {
      "deleteSchedule": true,
      "id": id
    }).then((response) => {
      setSchedules([...schedules.filter((schedule) => schedule.id != id)]);
    }).catch((error) => {
      SessionConfigs.displayError(error, setAlert);
    });
  };

  const skipTrainSchedule = (id, timestamp) => {
    SessionConfigs.queryData("/api/trainSchedule", {
      "skipSchedule": true,
      "id": id,
      "skippingUntil": timestamp
    }).then((response) => {
      setSchedules([...schedules.filter((schedule) => schedule.id != id)]);
    }).catch((error) => {
      SessionConfigs.displayError(error, setAlert);
    });
  };

  const sortSchedules = () => {
    setSchedules([...schedules.sort((a,b) => a.departTime < b.departTime)])
  };

  const getARankStatus = (world, patch) => {
    console.log(world)
    console.log(patch)
    SessionConfigs.queryData("/api/getInstanceRegions", {
      worldName: world
    }).then((response) => {
      var instanceRegions = response.data;
      let instancedRegionName = Object.keys(instanceRegions);

      var targetHunts = [];
      for (var key of Object.keys(huntInfos)) {
        if (huntInfos[key].Rank == 2) {
          if (huntInfos[key].Patch == patch) {
            if (instancedRegionName.includes(huntInfos[key].Region)) {
              for (var i = 0; i < instanceRegions[huntInfos[key].Region]; i++) {
                targetHunts.push(key + ` ${i+1}`);
              }
            } else {
              targetHunts.push(key);
            }
          }
        }
      }

      SessionConfigs.queryData("/api/trainStatus", {
        worldName: world,
        huntNames: targetHunts
      }).then((response) => {
        setTrainStatus({
          show: true,
          hunts: response.data
        })
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  React.useEffect(() => {
    function formatCountDownTimer(timestamp, scheduleTime) {
      var distance = timestamp - scheduleTime;
      if (distance > 0) {
        var hours = Math.floor(distance / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var textString = String(hours) + " " + SessionConfigs.dictionaryLookup("header", "timeHours") + " " + String(minutes) +  " " + SessionConfigs.dictionaryLookup("header", "timeMinutes") + " " + SessionConfigs.dictionaryLookup("header", "timeAgo");
      } else {
        distance *= -1;
        var hours = Math.floor(distance / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var textString = String(hours) + " " + SessionConfigs.dictionaryLookup("header", "timeHours") + " " + String(minutes) +  " " + SessionConfigs.dictionaryLookup("header", "timeMinutes") + " " + SessionConfigs.dictionaryLookup("header", "timeLater");
      }

      return textString;
    }

    const updateTimerFunc = () => {
      const currentTimestamp = new Date().getTime();
      for (let schedule of schedules) {
        let timer = document.getElementById(schedule.id + "_timer");
        if (timer) {
          let currentState = formatCountDownTimer(currentTimestamp, schedule.departTime);
          timer.innerHTML = currentState;
        }
      }
    }
    const updateTimer = setInterval(updateTimerFunc, 1000);

    for (let i in schedules) {
      schedules[i].show = timerConfigs.world[schedules[i].worldName] && timerConfigs.patch[schedules[i].patchName]
    }

    return () => {
      clearInterval(updateTimer);
    }

  }, [schedules]);

  return (
    <>
      <div className="content" >
        {alert}
        <audio src={notification} ref={audioRef}/>
        <Row style={{marginTop: 15}}>
          <ToastContainer
              style={{width: 400}}
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover
            />
          <Col xs={12}>
            <Card>
              <CardBody>
              {loadingState ? null : ([
                  <Box key={"tableTitle"} pt={1} px={3}>
                    <Row>
                      <Col xs={12}>
                        <LanguageDependentText header={"trainSchedule"} variant="h4" fontSize={24}/>
                      </Col>
                      <Col xs={12}>
                        <Button size="lg" variant="contained" color="secondary" onClick={() => setNewSchedule({show: true, conductor: "", conductorNote: "", patch: "", world: "", date: new Date(), time: new Date()})} style={{marginTop: 20, width: "100%"}}>
                          <LanguageDependentText header="trainScheduleNew" fontSize={20} fontWeight={"bold"}/>
                        </Button>
                      </Col>
                    </Row>
                  </Box>,
                  <Box key={"worldSelect"} pt={3} px={3}>
                    <LanguageDependentText header="worldSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"worldGroup"} pt={1} px={3}>
                    {worlds.map((world)=>(
                      (timerConfigs.world[world]) ? (
                      <Button id={rankType+world} key={world} variant="outlined" className="btn-selected" onClick={(event) => toggleWorldState(rankType, world, event)}>
                        <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button>
                      ) : (
                      <Button id={rankType+world} key={world} variant="outlined" onClick={(event) => toggleWorldState(rankType, world, event)}>
                        <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"patchSelect"} pt={1} px={3}>
                    <LanguageDependentText header="patchSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"patchGroup"} pt={1} px={3}>
                    {patches.map((patch)=>(
                      (timerConfigs.patch[patch]) ? (
                      <Button id={rankType+patch} key={patch} variant="outlined" className="btn-selected" onClick={(event) => togglePatchState(rankType, patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button>
                      ) : (
                      <Button id={rankType+patch} key={patch} variant="outlined" onClick={(event) => togglePatchState(rankType, patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"table"} pt={1} px={3}>
                    <Table style={{marginTop: 15, marginLeft: 5, marginRight: 5}}>
                      <thead>
                        <tr>
                          <th className="text-center" style={{width: "10%"}}>
                            <LanguageDependentText header={"tableWorldName"} variant="body2" fontSize={13} /> 
                          </th>
                          <th className="text-center" style={{width: "15%"}}>
                            <LanguageDependentText header={"tablePatchName"} variant="body2" fontSize={13} /> 
                          </th>
                          <th className="text-center" style={{width: "20%"}}>
                            <LanguageDependentText header={"tableConductor"} variant="body2" fontSize={13} /> 
                          </th>
                          <th className="text-center" style={{width: "20%"}}>
                            <LanguageDependentText header={"tableConductorNote"} variant="body2" fontSize={13} /> 
                          </th>
                          <th className="text-center" style={{width: "20%"}}>
                            <LanguageDependentText header={"tableDepartTimer"} variant="body2" fontSize={13} /> 
                          </th>
                          <th className="text-center" style={{width: "20%"}}>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {schedules.map((schedule) => {
                          const datacenter = getDataCenterName(schedule.worldName);
                          const allWorlds = dataCenters[datacenter]["Names"]
                          const badgeColorID = allWorlds.indexOf(schedule.worldName);

                          if (!schedule.show) return;
                          
                          return <tr key={schedule.id} data-world={schedule.worldName}>
                            <td>
                              <Badge as="<label>" className={"world-badge " + `world-color-${badgeColorID}`}>
                                {schedule.worldName.length > 5 ? schedule.worldName.slice(0,4) : schedule.worldName}
                              </Badge> 
                            </td>
                            <td>
                              <LanguageDependentText patchName={schedule.patchName} variant="body2" fontSize={15} /> 
                            </td>
                            <td>
                              <LanguageDependentText text={schedule.conductor} variant="body2" fontSize={15} /> 
                            </td>
                            <td>
                              <LanguageDependentText text={schedule.conductorNote} variant="body2" fontSize={13} /> 
                            </td>
                            <td>
                              <LanguageDependentText header={schedule.recurring} variant="body2" fontSize={15} /> 
                              <LanguageDependentText date={schedule.departTime} variant="body2" fontSize={15} /> 
                              <LanguageDependentText id={schedule.id+"_timer"} text={""} variant="body2" fontSize={15} /> 
                              <Button style={{marginTop: 0}} variant="contained" color="info" onClick={() => setEditSchedule({...editSchedule, id: schedule.id, date: new Date(), time: new Date(), show: true})}>
                                <LanguageDependentText header={"trainScheduleChangeDate"} variant="p" fontSize={12} /> 
                              </Button>
                            </td>
                            <td style={{display: "flex", flexDirection: "column"}}>
                              <Button style={{marginTop: 0}} variant="contained" color="info" onClick={() => getARankStatus(schedule.worldName, schedule.patchName)}>
                                <LanguageDependentText header={"trainScheduleProgress"} variant="p" fontSize={12} /> 
                              </Button>
                              {schedule.owned ? (<>
                                <Button style={{marginTop: 15}} variant="contained" color="error" onClick={() => deleteTrainSchedule(schedule.id)}>
                                  <LanguageDependentText header={"trainScheduleDelete"} variant="p" fontSize={12} /> 
                                </Button>
                                {schedule.recurring == "recurringDay" ? (
                                  <Button style={{marginTop: 15}} variant="contained" color="success" onClick={() => skipTrainSchedule(schedule.id, schedule.departTime)}>
                                    <LanguageDependentText header={"trainScheduleSkip"} variant="p" fontSize={12} /> 
                                  </Button>
                                ): null}
                              </>) : null}
                            </td>
                          </tr>
                        })}
                      </tbody>
                    </Table>
                  </Box>
                ])}
              </CardBody>
            </Card>
            
            <Modal isOpen={trainStatus.show} toggle={() => setTrainStatus({show: false, hunts: []})} size="md" contentClassName={"card border border-danger rounded"} backdrop={true}>
              <Box sx={{minHeight: "100%", padding: "24px", display: "flex", flexDirection: "column" }}>
                {trainStatus.hunts.map((hunt) => {
                  return <Row key={hunt.huntName} style={{paddingTop: 5, paddingBottom: 0}}>
                    <Col sm={6} style={{paddingTop: 0}}>
                      {hunt.deathTime ? (
                        <s>
                        <LanguageDependentText huntName={hunt.huntName} fontSize={15} />
                        </s>
                      ) : (
                        <LanguageDependentText huntName={hunt.huntName} fontSize={15} />
                      )}
                    </Col>
                    <Col sm={6} style={{paddingTop: 0}}>
                      {hunt.deathTime ? (
                        <i className="fa-solid fa-skull" style={{"color": "red"}}></i>
                      ) : (
                        null
                      )}
                    </Col>
                  </Row>
                })}
              </Box>
            </Modal>
            
            <Modal isOpen={newSchedule.show} toggle={() => setNewSchedule({show: false, conductor: "", conductorNote: "", patch: "", world: "", date: new Date(), time: new Date()})} size="md" contentClassName={"card border border-danger rounded"} backdrop={true}>
              <Box sx={{minHeight: "100%", padding: "24px", display: "flex", flexDirection: "column" }}>
                <Row style={{paddingTop: 15, paddingBottom: 0}}>
                  <Col sm={12}>
                    <LanguageDependentText header={"worldSelectTitle"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="Rank Filter"
                      closeMenuOnSelect={true}
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={newSchedule.world}
                      onChange={(value) => {
                        setNewSchedule({...newSchedule, world: value});
                      }}
                      options={worlds.map((world) => {
                        return {value: world, label: world}
                      })}
                    />
                  </Col>
                </Row>

                <Row style={{paddingTop: 15, paddingBottom: 0}}>
                  <Col sm={12}>
                    <LanguageDependentText header={"patchSelectTitle"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="Rank Filter"
                      closeMenuOnSelect={true}
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={newSchedule.patch}
                      onChange={(value) => {
                        setNewSchedule({...newSchedule, patch: value});
                      }}
                      options={patches.map((key) => {
                        return {value: key, label: patchList[key][language]}
                      })}
                    />
                  </Col>
                </Row>

                <Row style={{paddingTop: 15, paddingBottom: 0}}>
                  <Col sm={12}>
                    <Form action="#">
                      <FormGroup>
                        <LanguageDependentText variant="span" header={"tableConductor"} fontSize={15} fontWeight={"bold"}/>
                        <Input type="text" value={newSchedule.conductor} onChange={(event) => setNewSchedule({...newSchedule, conductor: event.currentTarget.value})} />
                      </FormGroup>
                      <FormGroup>
                        <LanguageDependentText variant="span" header={"tableConductorNote"} fontSize={15} fontWeight={"bold"}/>
                        <Input type="text" value={newSchedule.conductorNote} onChange={(event) => setNewSchedule({...newSchedule, conductorNote: event.currentTarget.value})} />
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>

                <Row style={{paddingTop: 15, paddingBottom: 0}}>
                  <Col sm={12}>
                    <LanguageDependentText header={"recurringOptions"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="Rank Filter"
                      closeMenuOnSelect={true}
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={newSchedule.recurring}
                      onChange={(value) => {
                        setNewSchedule({...newSchedule, recurring: value});
                      }}
                      options={[
                        {value: "recurringOnce", label: textLibrary("header", "recurringOnce")},
                        {value: "recurringDay", label: textLibrary("header", "recurringDay")},
                      ]}
                    />
                  </Col>
                </Row>

                <Row style={{paddingTop: 15, paddingBottom: 15}}>
                  <Col>
                    <LanguageDependentText header={"tableReportDate"} fontSize={15} />
                    <Flatpickr options={{
                      enableTime: false,
                      defaultDate: newSchedule.date
                    }} className={"form-control datetime-picker"} onChange={([date]) => { setNewSchedule({...newSchedule, date: new Date(date)}) }}/>
                  </Col>
                  <Col>
                    <LanguageDependentText header={"tableReportTime"} fontSize={15} />
                    <Flatpickr options={{
                      enableTime: true,
                      noCalendar: true,
                      minuteIncrement: 1,
                      allowInput: true,
                      defaultDate: newSchedule.time
                    }} className={"form-control datetime-picker"} onChange={([date]) => { setNewSchedule({...newSchedule, time: new Date(date)}) }}/>
                  </Col>
                </Row>
                <Button style={{marginTop: 15}} variant="contained" color="error" onClick={() => submitNewTrainSchedule()}>
                  {SessionConfigs.dictionaryLookup("header", "trainScheduleSubmit")}
                </Button>
              </Box>
            </Modal>
            
            <Modal isOpen={editSchedule.show} toggle={() => setEditSchedule({show: false, date: new Date(), time: new Date()})} size="md" contentClassName={"card border border-danger rounded"} backdrop={true}>
              <Box sx={{minHeight: "100%", padding: "24px", display: "flex", flexDirection: "column" }}>
                <Row style={{paddingTop: 15, paddingBottom: 15}}>
                  <Col>
                    <LanguageDependentText header={"tableReportDate"} fontSize={15} />
                    <Flatpickr options={{
                      enableTime: false,
                      defaultDate: editSchedule.date
                    }} className={"form-control datetime-picker"} onChange={([date]) => { setEditSchedule({...editSchedule, date: new Date(date)}) }}/>
                  </Col>
                  <Col>
                    <LanguageDependentText header={"tableReportTime"} fontSize={15} />
                    <Flatpickr options={{
                      enableTime: true,
                      noCalendar: true,
                      minuteIncrement: 1,
                      allowInput: true,
                      defaultDate: editSchedule.time
                    }} className={"form-control datetime-picker"} onChange={([date]) => { setEditSchedule({...editSchedule, time: new Date(date)}) }}/>
                  </Col>
                </Row>
                <Button style={{marginTop: 15}} variant="contained" color="error" onClick={() => submitEditTrainSchedule()}>
                  {SessionConfigs.dictionaryLookup("header", "trainScheduleSubmit")}
                </Button>
              </Box>
            </Modal>
            
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TrainSchedule;
